// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ChevronRight as RawChevronRight } from "lucide-react";
export const ChevronRight = /* @__PURE__ */ createIcon(RawChevronRight, "ChevronRight", 2);
